<template>
  <div class="asd20-list-category" v-if="label">
    <div class="asd20-list-category__label" v-html="label"></div>
    <asd20-badge v-if="badge" :value="badge" />
  </div>
</template>

<script>
import Asd20Badge from '../../components/atoms/Asd20Badge'
export default {
  name: 'Asd20ListCategory',

  components: { Asd20Badge },

  props: {
    label: { type: String, default: '' },
    badge: { type: Number, default: 0 },
  },
}
</script>

<style lang="scss" scoped>
@import '../../design/_mixins.scss';
@import '../../design/_variables.scss';

.asd20-list-category {
  position: relative;
  display: flex;
  // text-transform: uppercase;
  color: var(--color__secondary);
  font-family: var(--website-typography__font-family-headlines);
  font-size: 1.1rem;
  font-weight: bold;
  padding-bottom: space(0.25);
  padding-left: space(0.125);
  flex-basis: 100%;
  // border-bottom: 1px solid rgba(128, 128, 128, 0.125) !important;
}

.asd20-list-item + .asd20-list-category {
  margin-top: space(0.5);
}
</style>
